module.exports = __webpack_public_path__ + "static/media/logo192.d059821b.png";